// ----------------------------------------------------------------------------
// Component: Content Cards
// ----------------------------------------------------------------------------
//
// Section displaying a default card consisting of an image,
// title, content and button. It displays a 1, 2 or 3 column grid.
//
//
// ----------------------------------------------------------------------------

// Dependencies
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import 'snippets/swiper-controls/swiper-control';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// Style includes
import './_multicolumn.scss';

// Variables
var CAROUSEL_SELECTOR = '.carousel--multicolumn-mobile';
var CAROUSEL_CLASS = 'carousel--multicolumn-mobile';
var CAROUSEL_SECTION_SELECTOR = '.section__multicolumn';
var MOBILE_MEDIA_QUERY = '(max-width: 767px)';

// Helpers
function initMulticolumnCarousel(element, index) {
  var carouselEl = element.matches(CAROUSEL_SELECTOR) ? element : element.querySelector(CAROUSEL_SELECTOR);
  if (!carouselEl) return null;
  var sectionEl = carouselEl.closest(CAROUSEL_SECTION_SELECTOR) || element;
  var wrapperEl = carouselEl.querySelector('.swiper-wrapper');
  var slideCount = (wrapperEl === null || wrapperEl === void 0 ? void 0 : wrapperEl.querySelectorAll(':scope > *').length) || 0;

  // Skip Swiper for single slide
  if (slideCount <= 1) return null;
  var paginationEl = sectionEl.querySelector('.swiper-pagination');
  var prevEl = sectionEl.querySelector('.swiper-button-prev');
  var nextEl = sectionEl.querySelector('.swiper-button-next');
  wrapperEl === null || wrapperEl === void 0 || wrapperEl.querySelectorAll(':scope > *').forEach(slideEl => {
    slideEl.classList.add('swiper-slide');
  });
  carouselEl.classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    modules: [Navigation, Pagination, A11y, Keyboard],
    slideClass: 'shopify-block',
    slidesPerView: 'auto',
    slidesOffsetAfter: 16,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    a11y: false,
    watchOverflow: true,
    navigation: {
      prevEl,
      nextEl
    },
    pagination: {
      el: paginationEl,
      clickable: true
    }
  });
  return swiper;
}

// Hooks
var multicolumnInstances = new Map();
function mountMulticolumnSections() {
  multicolumnInstances.forEach(swiper => swiper.destroy(true, true));
  multicolumnInstances.clear();
  if (!window.matchMedia(MOBILE_MEDIA_QUERY).matches) return;
  document.querySelectorAll(CAROUSEL_SELECTOR).forEach((element, index) => {
    var swiper = initMulticolumnCarousel(element, index);
    if (swiper) multicolumnInstances.set(element, swiper);
  });
}
mountMulticolumnSections();
document.addEventListener('shopify:section:load', event => {
  var isMulticolumn = event.target.matches(CAROUSEL_SECTION_SELECTOR) || event.target.querySelector(CAROUSEL_SELECTOR);
  if (isMulticolumn) {
    mountMulticolumnSections();
  }
});
window.matchMedia(MOBILE_MEDIA_QUERY).addEventListener('change', () => {
  mountMulticolumnSections();
});